package one.healthium.insights.ui.insights.components

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.compose.ui.util.fastForEach
import loco.INSIGHTS_TAB_ALL
import loco.INSIGHTS_TAB_FAVORITES
import loco.INSIGHTS_TAB_RECENTLY_VIEWED
import one.healthium.loco.LString
import one.healthium.loco.asLString
import one.healthium.loco.resolve
import one.healthium.ui.compose.components.AppButton
import one.healthium.ui.compose.components.AppButtonDefaults
import one.healthium.ui.compose.theme.AppTheme
import one.healthium.ui.compose.theme.gray_3
import one.healthium.ui.compose.theme.white

enum class InsightTabs {
    All, Recent, Favorites
}

@Composable
internal fun InsightTabsContainer(
    currentTab: InsightTabs,
    onTabClicked: (InsightTabs) -> Unit,
    content: @Composable (InsightTabs) -> Unit,
) {
    Column {
        Tabs(
            currentTab = currentTab,
            onClick = onTabClicked,
        )
        InsightTabs.entries.fastForEach { tab ->
            AnimatedVisibility(
                visible = currentTab == tab,
                enter = fadeIn(),
                exit = fadeOut(),
            ) {
                content(tab)
            }
        }
    }
}

@Composable
private fun Tabs(
    onClick: (InsightTabs) -> Unit,
    currentTab: InsightTabs,
) {
    Row(
        modifier = Modifier
            .padding(horizontal = 16.dp)
            .horizontalScroll(rememberScrollState()),
        horizontalArrangement = Arrangement.spacedBy(6.dp),
    ) {
        InsightTabs.entries.fastForEach { tab ->
            TabItem(
                modifier = Modifier,
                tab = tab,
                selected = currentTab == tab,
                onClick = { onClick(tab) },
            )
        }
    }
}

@Composable
private fun TabItem(
    modifier: Modifier,
    tab: InsightTabs,
    selected: Boolean,
    onClick: () -> Unit,
) {
    AppButton(
        modifier = modifier,
        onClick = onClick,
        minHeight = 36.dp,
        contentPadding = PaddingValues(horizontal = 16.dp, vertical = 9.dp),
        colors = if (selected) {
            AppButtonDefaults.primaryButtonColors
        } else {
            AppButtonDefaults.appButtonColors(containerColor = white, contentColor = gray_3)
        },
    ) {
        Text(
            text = tab.displayName.resolve(),
            style = AppTheme.textStyles.secondary_14_500,
        )
    }
}

private val InsightTabs.displayName: LString
    get() = when (this) {
        InsightTabs.All -> loco.Res.string.INSIGHTS_TAB_ALL.asLString()
        InsightTabs.Recent -> loco.Res.string.INSIGHTS_TAB_RECENTLY_VIEWED.asLString()
        InsightTabs.Favorites -> loco.Res.string.INSIGHTS_TAB_FAVORITES.asLString()
    }